import React from 'react';

import { Link as RouterLink } from 'react-router-dom';

import PropTypes from 'prop-types';

import { Box, Typography } from '@mui/material';

import { COLORS } from '../../../Constant/COLORS';

import { getCategoryIcon, hasRealImage } from '../../../Helpers/categoryIcon';

// Premium category tile: an uploaded icon when there is one, otherwise a modern
// lucide icon picked from the category name — so every category always shows a
// crisp, on-brand icon inside a soft gradient badge.
const ItemIcoDesc = ({ src, text, to, sx, ...rest }) => {
  const Icon = getCategoryIcon(text);
  const showImage = hasRealImage(src);

  return (
      <Box
        component={RouterLink}
        to={to}
        {...rest}
        sx={{
          display: 'block',
          textDecoration: 'none',
          height: '100%',
          p: { xs: 2.5, md: 3 },
          borderRadius: 4,
          border: `1px solid ${COLORS.hairline}`,
          bgcolor: COLORS.surface,
          textAlign: 'center',
          transition: 'transform .2s ease, box-shadow .2s ease, border-color .2s ease',
          '&:hover': {
            transform: 'translateY(-6px)',
            borderColor: COLORS.teal,
            boxShadow: '0 16px 34px rgba(14, 27, 31, 0.10)',
          },
          '&:hover .cat-badge': {
            background: `linear-gradient(135deg, ${COLORS.teal}, ${COLORS.tealDark})`,
            color: '#fff',
          },
          ...sx,
        }}
      >
        <Box
          className='cat-badge'
          sx={{
            width: 66,
            height: 66,
            mx: 'auto',
            mb: 1.75,
            borderRadius: '50%',
            background: `linear-gradient(135deg, ${COLORS.tealSoft}, ${COLORS.surface})`,
            border: `1px solid ${COLORS.hairline}`,
            color: COLORS.teal,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            transition: 'background .25s ease, color .25s ease',
          }}
        >
          {showImage ? (
            <img
              src={src}
              alt=''
              style={{ width: 34, height: 34, objectFit: 'contain' }}
            />
          ) : (
            <Icon size={28} strokeWidth={1.6} />
          )}
        </Box>
        <Typography fontWeight={600} color={COLORS.ink}>
          {text}
        </Typography>
      </Box>
  );
};

ItemIcoDesc.propTypes = {
  src: PropTypes.string,
  text: PropTypes.string.isRequired,
  to: PropTypes.string.isRequired,
  sx: PropTypes.object,
};

export default ItemIcoDesc;
